import { requestGet, requestPost} from './request';

interface ICreateFolder {
    type?: number; // 2:S2 1:S1 0:BOOK
    title: string;
    intro: string;
    ages: string;
    tags: string;
    imageUrl?: string;
    rootId: number;
}

interface IUpdateFolder {
    id: number;
    title: string;
    intro: string;
    ages: string;
    tags: string;
    imageUrl?: string;
    rootId: number;
    parentId?: number;
}

interface IDeleteFolder {
    id: number;
}

interface IMoveFolder {
    parentId: number | undefined;
    ids: number[];
}

interface IFolderResponse {
    id: number;
    parentChildShowType: number;
    rootChildShowType: number;
    type: number; // 0 绘本，非 0 是目录
    title: string;
    titleLang: string;
    wordsCnt: number;
    bookCnt: number;
    childShowType: number;
    childCnt: number;
    mediaUrl: string;
    categories: number[];
    vip: number;
    status: number;
    wordBookLearning: boolean;
    learnedCount: number;
    inMyWordBook: boolean;
}

interface IUpLoader {
    id: number;
    type: number;
    nickName: string;
    permanentVip: boolean;
    permanentSvip: boolean;
}

interface IDirectoryItem {
    id: number;
    parentId: number;
    parentChildShowType: number;
    rootChildShowType: number;
    type: number;
    title: string;
    titleLang: string;
    wordsCnt: number;
    childShowType: number;
    childCnt: number;
    mediaUrl: string;
    categories: number[];
    vip: number;
    status: number;
    wordBookLearning: boolean;
    learnedCount: number;
    inMyWordBook: boolean;
}

interface IDirectoryResponse {
    id: number;
    parentChildShowType: number;
    seriesId: number;
    rootChildShowType: number;
    type: number;
    title: string;
    titleLang: string;
    wordsCnt: number;
    bookCnt: number;
    childShowType: number;
    childCnt: number;
    mediaUrl: string;
    categories: number[];
    vip: number;
    upLoader: IUpLoader;
    items: IDirectoryItem[];
    hasMore: boolean;
    wordBookLearning: boolean;
    learnedCount: number;
    inMyWordBook: boolean;
}

// 创建目录
export function createFolder(params: ICreateFolder) {
    return requestPost<IFolderResponse>('/v1/bookCreation/add', { ...params });
}

// 更新目录
export function updateFolder(params: IUpdateFolder) {
    return requestPost<IFolderResponse>('/v1/bookCreation/update', params);
}

// 删除目录
export function deleteFolder(params: IDeleteFolder) {
    return requestPost('/v1/bookCreation/delete', params);
}

// 获取目录或绘本列表
export function getDirectoryById(id: number) {
    return requestGet<IDirectoryResponse>(`/v1/directory/${id}`, {});
}

// 移动/排序目录
export function moveFolder(params: IMoveFolder) {
    return requestPost('/v1/bookCreation/move', params);
}